// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__eWvRk","title":"Header_title__WeEjP","left":"Header_left__3m8WT","clinicName":"Header_clinicName__r3MX-"};